import React from "react";
import { styled } from '@mui/styles';
import Stack from "@mui/material/Stack";

import { MixPanelTrackedLink } from "../../../components";

export default function () {
    return <StyledEventButtons spacing={1}>
        <MixPanelTrackedLink type="button" label="Buy Ticket" context="Event details page event card" variant="contained">Buy Ticket</MixPanelTrackedLink>
        <MixPanelTrackedLink type="button" label="General donation" context="Event details page event card" variant="contained" color="secondary">General Donation</MixPanelTrackedLink>
        <Stack direction={'row'} spacing={1}>
            <MixPanelTrackedLink className="PledgeButton" type="button" label="Pledge" context="Event details page event card" variant="contained" color="secondary">Pledge</MixPanelTrackedLink>
            <MixPanelTrackedLink className="RSVPButton" type="button" label="RSVP" context="Event details page event card" variant="contained">RSVP</MixPanelTrackedLink>
        </Stack>
    </StyledEventButtons>
}

const StyledEventButtons = styled(Stack)(({ theme }) => ({
    '& .MuiButtonBase-root': {
        fontWeight: 600,
        fontSize: '1rem'
    },
    '& .PledgeButton': {
        backgroundColor: theme.palette.secondary.light, 
        color: 'white',
        width: '100%'
    },
    '& .RSVPButton': {
        backgroundColor: '#673401',
        width: '100%'
    },
}));